var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardHiImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 188,
    viewBox: "0 0 1120 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1915_20881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H1112C1116.42 0 1120 3.58172 1120 8V180C1120 184.418 1116.42 188 1112 188H7.99998C3.5817 188 0 184.418 0 180V8Z",
    fill: "#9F55FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M702.487 -283.967L702.487 -283.966C559.653 -255.226 438.153 -148.421 397.891 1.83835C341.306 213.019 466.615 430.089 677.827 486.683C889.014 543.27 1106.09 417.944 1162.68 206.763C1219.27 -4.44159 1093.94 -221.518 882.751 -278.105C858.508 -284.601 834.21 -288.703 810.068 -290.533C773.503 -293.334 737.349 -290.976 702.487 -283.967ZM1001.06 -60.0651L1001.06 -60.0641C1035.24 -12.5766 1054.06 45.6897 1052.66 106.294L918.655 70.3876C907.179 20.1718 869.277 -22.0672 816.389 -36.2384C739.999 -56.7072 661.342 -10.7986 640.687 66.2842C636.897 80.429 635.32 94.6258 635.746 108.532C609.315 72.3584 598.71 27.5651 610.349 -15.8738C616.926 -40.4188 629.841 -61.747 647.218 -78.9472L647.222 -78.9513C651.623 -83.327 656.326 -87.4253 661.281 -91.2345L663.138 -92.6615L661.835 -94.6072L637.562 -130.865C699.265 -169.602 776.03 -183.568 851.635 -163.309C914.26 -146.529 965.831 -109.045 1001.06 -60.0651ZM709.78 366.101C573.289 329.529 489.266 194.464 512.572 56.8103C532.002 148.807 595.322 224.485 684.887 248.484C759.806 268.559 836.877 248.131 896.839 200.001L1018.92 232.712C959.869 341.001 833.239 399.182 709.78 366.101Z",
    stroke: "#CCB1FF",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H1112C1116.14 0.5 1119.5 3.85786 1119.5 8V180C1119.5 184.142 1116.14 187.5 1112 187.5H7.99998C3.85785 187.5 0.5 184.142 0.5 180V8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    stroke: "#CCB1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1915_20881"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H1112C1116.42 0 1120 3.58172 1120 8V180C1120 184.418 1116.42 188 1112 188H7.99998C3.5817 188 0 184.418 0 180V8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHiImg);
export default __webpack_public_path__ + "static/media/dashboard_hi_img.ab3c7b460de9328f59e9fc7960f4e3bb.svg";
export { ForwardRef as ReactComponent };